// extracted by mini-css-extract-plugin
export default {"main":"Interlineales_main__WXp6i"};